<template>
  <div class="space-y-1">
    <!-- Language tabs -->
    <div class="flex border-b border-neautrals-200">
      <button
        v-for="lang in languages"
        :key="lang"
        type="button"
        @click="activeTab = lang"
        :class="[
          'px-3 py-1 text-xs font-semibold uppercase tracking-wide transition-colors',
          activeTab === lang
            ? 'border-b-2 border-primary-600 text-primary-600 -mb-px'
            : 'text-neautrals-400 hover:text-neautrals-700'
        ]"
      >
        {{ lang }}
      </button>
    </div>

    <component
      :is="multiline ? 'textarea' : 'input'"
      :value="modelValue?.[activeTab] ?? ''"
      @input="onInput"
      :type="multiline ? undefined : 'text'"
      :rows="multiline ? rows : undefined"
      :placeholder="placeholder"
      class="w-full px-3 py-2 text-xs border border-neautrals-200 rounded-md outline-none focus:border-neautrals-900 transition-colors bg-white text-neautrals-800 placeholder-neautrals-400 resize-none"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

interface Props {
  modelValue?: Record<string, string>
  languages?: string[]
  placeholder?: string
  multiline?: boolean
  rows?: number
}

const props = withDefaults(defineProps<Props>(), {
  languages: () => ['en', 'es', 'pt'],
  placeholder: '',
  multiline: false,
  rows: 3
})

const emit = defineEmits<{ 'update:modelValue': [value: Record<string, string>] }>()

const activeTab = ref(props.languages[0] ?? 'en')

const onInput = (e: Event) => {
  const val = (e.target as HTMLInputElement | HTMLTextAreaElement).value
  emit('update:modelValue', { ...(props.modelValue ?? {}), [activeTab.value]: val })
}
</script>
